module.exports = __webpack_public_path__ + "static/media/Calibre-Semibold.34780840.woff";